export function setAccessToken(rootState) {
  if(rootState.insightSessionToken) return `Insight token=${rootState.insightSessionToken}`
  if(rootState.user && rootState.user.user && rootState.user.user.data.accessToken) return `Token token=${rootState.user.user.data.accessToken}`
  return
}